import React from "react";

const Footer = () => {
    return (
        <div className="h-12 bg-violet-700 w-screen flex justify-center items-center">
            <span className="text-white">©2023 All star wars production</span>
        </div>
    );
};

export default Footer;
